import { Checkbox } from "@/components/ui/checkbox";
import { CityInput } from "types";
import { DecreeAnalysisEmailConfig } from "./DecreeAnalysisEmailConfig";
import { FormField } from "@/components/ui/form";
import { useFormContext } from "react-hook-form";

export const DecreeAnalysisConfig = () => {
  const { control, watch } = useFormContext<CityInput>();
  const enableDecreeAnalysis = watch("options.decreeAnalysis.enabled");

  return (
    <div className="px-4 pt-4 pb-2 text-sm space-y-4">
      <FormField
        control={control}
        name="options.decreeAnalysis.enabled"
        render={({ field }) => (
          <div className="flex items-center space-x-2">
            <Checkbox id="decreeAnalysis" checked={!!field.value} onCheckedChange={field.onChange} />
            <label htmlFor="decreeAnalysis" className="text-sm font-medium leading-none">
              Activer l'analyse des arrêtés
            </label>
          </div>
        )}
      />
      {enableDecreeAnalysis && <DecreeAnalysisEmailConfig />}
    </div>
  );
};
